<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">DEMANDE DE CONTRAT</span>
        <h3 class="page-title">{{ "Pour " + user.firstName + " " + user.lastName }}</h3>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4 mt-3" v-if="loading || !user.connected">
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <template v-else>
          <step-one v-if="step === 1" :user.sync="user" @input="handleStepOne" />
          <step-two v-else-if="step === 2" :user.sync="user" @input="handleStepTwo" :isCEE="isCEE" />
          <step-three v-else-if="step === 3" :user.sync="user" :request="request" @input="handleStepThree"></step-three>
        </template>
      </div>
    </div>
  </div>
</template>
  
<script>
import daysOffType from "../../data/daysOff/daysOffType.js";
import contractType from '../../data/contract/contractType';
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import StepOne from "../../components/contract/request/StepOne.vue";
import StepTwo from "../../components/contract/request/StepTwo";
import StepThree from "../../components/contract/request/StepThree";
import TimeUtils from "../../utils/TimeUtils";
export default {
  name: "contract-request",
  components: {
    StepThree,
    StepTwo,
    StepOne,
    SpinnerDot
  },
  mounted() {
    console.log(this.requests);
    this.$services.user.getUsers()
      .then((data) => {
        data.data.forEach((user) => {
          if (user.permissions[0] && user.permissions[0].groupReference == '_super_admin') {
            this.adminRef.push(user.reference);
          }
        })
      }
      ).catch((e) => console.log("error: ", e))
  },
  data() {
    return {
      request: {},
      step: 1,
      loading: false,
      daysOffType,
      requests: [],
      adminRef: [],
      isCEE: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    }
  },

  methods: {
    handleStepOne(event) {
      if (event == "CEE") {
        this.isCEE = true;
      } else {
        this.isCEE = false;
      }
      console.log("event from step one : ", event);
      this.step = 2;
    },

    handleStepTwo(answer) {
      console.log("handle Step Two : ", answer);
      if (!answer) {
        this.step = 1;
      } else {
        this.request.type = answer.type;
        this.request.upToDate = answer.upToDate;
        this.request.firstName = answer.firstName;
        this.request.lastName = answer.lastName;
        this.request.phoneNumber = answer.phoneNumber;
        this.request.dateOfBirth = answer.dateOfBirth;
        this.request.adresse = answer.adresse;
        this.request.socialSecurityNumber = answer.socialSecurityNumber;
        this.request.poleEmploiInscriptionNumber = answer.poleEmploiInscriptionNumber;
        this.request.selectedStructure = answer.selectedStructure;
        this.request.CVPath = answer.CVPath.path;
        this.request.IDPath = answer.IDPath.path;
        this.request.otherDocumentsPaths = answer.otherDocumentsPaths;
        this.request.dateFrom = answer.dateFrom;
        this.request.dateTo = answer.dateTo;
        this.request.Remarques = answer.Remarques;
        this.request.email = answer.email;
        this.request.otherContract = answer.otherContract;
        this.request.isMale = answer.isMale;
        this.request.nationality = answer.nationality,
        this.request.birthPlace = answer.birthPlace,
        this.request.city = answer.city,
        this.request.postalCode = answer.postalCode,
        this.request.fonction = answer.fonction,
        this.request.daysOfContractPast11Months = answer.daysOfContractPast11Months,
        this.request.CEEType = this.isCEE ? answer.CEEType : "",
        this.request.daysOfContract = answer.daysOfContract, 
        // console.log("handle step two wiht : ", this.request);
        this.step = 3;
      }
    },

    getDate(value, date) {
      if (value) {
        if (value == 2) {
          return TimeUtils.getMiddleOfDay(date).valueOf();
        }

        return TimeUtils.getFirstHalfOfDay(date).valueOf();
      }

      return TimeUtils.getEndOfDay(date).valueOf();
    },

    handleStepThree(answer) {
      if (!answer) {
        this.step = 2;
      } else {
        this.loading = true;
        const form = {
          firstName: this.request.firstName,
          lastName: this.request.lastName,
          dateOfBirth: this.request.dateOfBirth,
          phoneNumber: this.request.phoneNumber,
          address: this.request.adresse,
          socialSecurityNumber: this.request.socialSecurityNumber,
          poleEmploiInscriptionNumber: this.request.poleEmploiInscriptionNumber,
          typeOfContract: this.request.type,
          structureID: this.request.selectedStructure.id,
          structureName: this.request.selectedStructure.name,
          upToDate: this.request.upToDate,
          CVPath: this.request.CVPath,
          IDPath: this.request.IDPath,
          otherDocumentsPaths: this.request.otherDocumentsPaths,
          dateFrom: this.request.dateFrom,
          dateTo: this.request.dateTo,
          applicantID: this.user.reference,
          applicantFirstName: this.user.firstName,
          applicantLastName: this.user.lastName,
          remarques: this.request.Remarques,
          email: this.request.email,
          otherContract: this.request.otherContract,
          ContractPath: "",
          refuseReason: "",
          creationDate: new Date(),
          lastUpdateDate: new Date(),
          status: "PENDING",
          isMale: this.request.isMale,
          nationality: this.request.nationality,
          birthPlace: this.request.birthPlace,
          city: this.request.city,
          postalCode: this.request.postalCode,
          fonction: this.request.fonction,
          daysOfContractPast11Months: this.request.daysOfContractPast11Months,
          CEEType: this.request.CEEType,
          daysOfContract: this.request.daysOfContract, 
        };
        this.$services.contractRequestService.create(form).then(() => {
          localStorage.removeItem('model');
          console.log("*********************: ", form);
          this.$miniToastr.success(this.$t("days.off.request.success"));
          this.$router.push("/demandes/historique");
        }).catch((e) => {
        console.log("error: ", e)
        this.$miniToastr.error("Une erreur s'est produite."); 
      });
      }
    },
  }
};
</script>
  
<style lang="scss" scoped>
.main-content>.main-content-container.container-fluid {
  min-height: calc(100vh - #{3.75rem + 3.75rem});

  @media screen and (min-width: 320px) and (max-width: 767px) {
    height: 910px;
  }
}
</style>
  